(function(){
  if (window.__sshHome) return; window.__sshHome = true;

  // Sliding rows and story circles: arrows, mouse drag with momentum, overflow fade.
  function setupSlider(wrap){
    if (wrap.__sh) return; wrap.__sh = true;
    var track = wrap.querySelector('[data-sh-track]'); if (!track) return;
    var prev = wrap.querySelector('[data-sh-prev]'), next = wrap.querySelector('[data-sh-next]');
    function upd(){
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      wrap.classList.toggle('is-overflow', max > 2 && track.scrollLeft < max);
    }
    function step(){ return Math.max(track.clientWidth * 0.8, 160); }
    if (prev) prev.addEventListener('click', function(){ track.scrollBy({left: -step(), behavior: 'smooth'}); });
    if (next) next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior: 'smooth'}); });
    track.addEventListener('scroll', upd, {passive: true});
    window.addEventListener('resize', upd);
    // mouse drag (touch uses native scrolling)
    var down = false, moved = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0, raf;
    track.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = lx = e.clientX; sl = track.scrollLeft; lt = performance.now(); v = 0; cancelAnimationFrame(raf);
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5){ moved = true; track.classList.add('is-drag'); }
      if (!moved) return;
      var now = performance.now(); v = (e.clientX - lx) / Math.max(now - lt, 1); lx = e.clientX; lt = now;
      track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function(){
      if (!down) return; down = false;
      if (!moved) return;
      var vel = -v * 16;
      (function glide(){
        if (Math.abs(vel) < 0.5){ track.classList.remove('is-drag'); return; }
        track.scrollLeft += vel; vel *= 0.92; raf = requestAnimationFrame(glide);
      })();
    });
    track.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    upd(); setTimeout(upd, 400);
  }

  // Count-up numbers when scrolled into view.
  function fmt(n){ return Math.round(n).toLocaleString('en-AU'); }
  function setupCount(el){
    if (el.__sh) return; el.__sh = true;
    var target = parseFloat(el.getAttribute('data-sh-count')) || 0;
    var dur = parseFloat(el.getAttribute('data-sh-dur')) || 2200;
    if (!('IntersectionObserver' in window)) return;
    el.textContent = fmt(0);
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return; io.disconnect();
        var st = null;
        (function tick(ts){
          if (!st) st = ts;
          var p = Math.min((ts - st) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(target * e);
          if (p < 1) requestAnimationFrame(tick);
        })(performance.now());
      });
    }, {threshold: 0.4});
    io.observe(el);
  }

  // Videos: play muted while on screen, pause when off screen.
  function setupVideo(card){
    if (card.__sh) return; card.__sh = true;
    var vid = card.querySelector('video'); if (!vid) return;
    vid.muted = true; vid.setAttribute('muted', ''); vid.playsInline = true;
    var btn = card.querySelector('[data-sh-mute]');
    if (btn) btn.addEventListener('click', function(e){
      e.preventDefault(); vid.muted = !vid.muted; card.classList.toggle('is-sound', !vid.muted);
      if (vid.paused) vid.play().catch(function(){});
    });
    if (!('IntersectionObserver' in window)){ vid.play().catch(function(){}); return; }
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.intersectionRatio > 0.35){ vid.play().catch(function(){}); }
        else { vid.pause(); }
      });
    }, {threshold: [0, 0.35, 0.7]}).observe(card);
  }

  function init(root){
    root = root || document;
    root.querySelectorAll('[data-sh-wrap]').forEach(setupSlider);
    root.querySelectorAll('[data-sh-count]').forEach(setupCount);
    root.querySelectorAll('[data-sh-video]').forEach(setupVideo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
